export interface FormListEntity {
  id: string;
  name: string;
  link: string;
  imageUrl: string;
  locationId: string;
  description: string;
}

export namespace FormListEntity {
  export function fromJSON(data: any[]): FormListEntity[] {
    return data.map((e) => ({
      id: e.formID,
      link: e.formUrl,
      name: e.formName,
      imageUrl: e.imageUrl,
      locationId: e.locationID,
      description: e.formDescription,
    }));
  }
}
